<div
  class="loader-overlay"
  *ngIf="isVisible"
  role="status"
  aria-live="polite"
  aria-label="Loading"
>
  <img
    src="assets/images/favicon.webp"
    alt="Loading"
    class="loader-image"
    width="100"
    height="100"
  />
</div>